export const SAVED_MESSAGE_ID = "savedMessageId"
export const SAVED_MESSAGE_STATUS = "savedMessage_Status"
export const CALENDAR_MESSAGE = "calendarMessage"
export const CALENDAR_FILTER_STATUS = "calendarFilterStatus"


